import React from 'react';
import styles from './PhoneMockup.module.css';

interface PhoneMockupProps {
  src: string;
  alt: string;
}

export function PhoneMockup({ src, alt }: PhoneMockupProps) {
  return (
    <div className={styles.glow}>
      <div className={styles.frame}>
        <span className={styles.island} aria-hidden="true" />
        <span className={`${styles.btn} ${styles.volRocker}`} aria-hidden="true" />
        <span className={`${styles.btn} ${styles.power}`} aria-hidden="true" />
        <div className={styles.screen}>
          <img className={styles.shot} src={src} alt={alt} loading="lazy" />
        </div>
      </div>
    </div>
  );
}
